import {
  Config,
  ConfigServiceDataKeys,
  DeprecatedThemeParameterMap,
  EmptyThemeParameterMap,
  NonFlatConfigParameterKeys,
  THEME_QUERY_PARAM_PREFIX,
} from '@evenfinancial/even-ts-static'
import { deleteEmptyObjectValues, getValue, setValue } from '../object'

const validateStyleObject = (object, key) => {
  let styles = object[key]
  if (typeof styles === 'string') {
    try {
      styles = JSON.parse(styles)
    } catch {
      styles = {}
    }
  }
  return styles
}

export const getMergedStyleObject = (config, paramName: string) => {
  let configObject = {}
  Object.keys(config).forEach((key) => {
    if (config[key]) {
      let styles = config[key]
      if (NonFlatConfigParameterKeys.includes(`theme.${key}` as ConfigServiceDataKeys)) {
        styles = validateStyleObject(config, key)
      }
      configObject = setValue(configObject, key, styles)
    }
  })
  let mergedStyleObject = { [paramName]: {} }
  const styleMappings = DeprecatedThemeParameterMap[paramName] ?? {}
  Object.keys(styleMappings).forEach((key) => {
    mergedStyleObject[paramName][key] = getValue(configObject, `${styleMappings[key]}`)
  })

  mergedStyleObject = { ...mergedStyleObject[paramName], ...validateStyleObject(configObject, paramName) }

  return deleteEmptyObjectValues(mergedStyleObject)
}

export const getThemeConfigMerged = (config: Config) => {
  const themeConfig = {}
  Object.keys(config).forEach((key) => {
    if (key.startsWith(THEME_QUERY_PARAM_PREFIX)) {
      themeConfig[key.replace(THEME_QUERY_PARAM_PREFIX, '')] = config[key]
    }
  })

  let themeMerged: object = {
    'theme.backdropStyles': getMergedStyleObject(themeConfig, 'backdropStyles'),
    'theme.ctaStyles': getMergedStyleObject(themeConfig, 'ctaStyles'),
    'theme.errorStyles': getMergedStyleObject(themeConfig, 'errorStyles'),
    'theme.headlineStyles': getMergedStyleObject(themeConfig, 'headlineStyles'),
    'theme.labelStyles': getMergedStyleObject(themeConfig, 'labelStyles'),
  }

  Object.keys(EmptyThemeParameterMap).forEach((key) => {
    const keys = [`${THEME_QUERY_PARAM_PREFIX}${key.split('.')[0]}`, key.split('.')[1]]
    const currentValue = getValue(themeMerged, keys)
    const fallbackValue = getValue(themeConfig, `${EmptyThemeParameterMap[key]}`)
    if (!currentValue && !!fallbackValue) {
      themeMerged = setValue(themeMerged, keys, fallbackValue)
    }
  })

  return themeMerged
}

// until we backfill and remove old theme params
export const getThemeExtended = (defaultConfig, partnerConfig, qpConfig) => {
  const defaultConfigResult = getThemeConfigMerged(defaultConfig)
  const partnerConfigResult = getThemeConfigMerged(partnerConfig)
  const qpConfigResult = getThemeConfigMerged(qpConfig)

  return {
    'theme.backdropStyles': {
      ...defaultConfigResult['theme.backdropStyles'],
      ...partnerConfigResult['theme.backdropStyles'],
      ...qpConfigResult['theme.backdropStyles'],
    },
    'theme.ctaStyles': {
      ...defaultConfigResult['theme.ctaStyles'],
      ...partnerConfigResult['theme.ctaStyles'],
      ...qpConfigResult['theme.ctaStyles'],
    },
    'theme.errorStyles': {
      ...defaultConfigResult['theme.errorStyles'],
      ...partnerConfigResult['theme.errorStyles'],
      ...qpConfigResult['theme.errorStyles'],
    },
    'theme.headlineStyles': {
      ...defaultConfigResult['theme.headlineStyles'],
      ...partnerConfigResult['theme.headlineStyles'],
      ...qpConfigResult['theme.headlineStyles'],
    },
    'theme.labelStyles': {
      ...defaultConfigResult['theme.labelStyles'],
      ...partnerConfigResult['theme.labelStyles'],
      ...qpConfigResult['theme.labelStyles'],
    },
  }
}
